export const setReserveData = (state, params) => {
	const { payload: reserve } = params;
	state.reserve = reserve;
	return state;
};

export const setClientData = (state, params) => {
	const { payload: client } = params;
	state.client = client;
	return state;
};

export const setVehicleData = (state, params) => {
	const { payload: vehicle } = params;
	state.vehicle = vehicle;
	return state;
};

export default {};